"use client";

import { NoClientAccess } from "./NoClientAccess";

interface ClientAccessGuardProps {
  isClientUser: boolean;
  hasContactAccess: boolean;
  userEmail: string;
  children: React.ReactNode;
}

/**
 * Access guard component that handles conditional rendering based on client access
 * Determines whether to show the NoClientAccess component or render children
 */
export function ClientAccessGuard({
  isClientUser,
  hasContactAccess,
  userEmail,
  children,
}: ClientAccessGuardProps) {
  // Show NoClientAccess if user is a client but has no access
  if (isClientUser && !hasContactAccess) {
    return <NoClientAccess userEmail={userEmail} />;
  }

  // Render children if user has access or is not a client user
  return <>{children}</>;
}
